import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BackendService } from './backend.service';
import { constants } from '../constants';
import { CustomHttpParamEncoder } from '../encoder/custom-http-param-encoder';
import { isEmpty } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class PostService {
  baseUrl: string = `${environment.baseUrl}/`;
  postController = 'post/';

  constructor(private backend: BackendService) {}

  getForumTopics(page: number, size: number): Observable<any> {
    const pageSize = size || constants.TABLE_ROWS;
    let params = new HttpParams({ encoder: new CustomHttpParamEncoder() }).set('p', `${page}`).set('page_size', `${pageSize}`);

    return this.backend.getWithParams(`${this.baseUrl}${this.postController}admin/`, { params }).pipe(
      map((res: any) => {
        const { data = [], count } = res;
        const items = isEmpty(data)
          ? []
          : data.map((item) => {
              const short_id = item.post_id.split('-')[0];
              const category = item.post_category.post_category_name;
              const created_by = item.user.first_name + ' ' + item.user.last_name;
              return { ...item, created_by, short_id, category };
            });

        return { items, count };
      }),
      catchError((errorRes) => throwError(() => errorRes)),
    );
  }

  deleteForumTopic(forumTopicId: string) {
    return this.backend.delete(`${this.baseUrl}${this.postController}admin/delete/${forumTopicId}/`).pipe(
      map((res) => res),
      catchError((errorRes) => throwError(() => errorRes)),
    );
  }

  getForumCategories(page: number, size: number): Observable<any> {
    const pageSize = size || constants.TABLE_ROWS;
    let params = new HttpParams({ encoder: new CustomHttpParamEncoder() }).set('p', `${page}`).set('page_size', `${pageSize}`);

    return this.backend
      .getWithParams(`${this.baseUrl}${this.postController}category/all/`, {
        params,
      })
      .pipe(
        map((res) => {
          const { data = [], count } = res;
          const items = isEmpty(data)
            ? []
            : data.map((item) => {
                const created_by = isEmpty(item?.created_by) ? '' : item?.created_by?.first_name + ' ' + item?.created_by?.last_name;
                return { ...item, created_by };
              });

          return { items, count };
        }),
        catchError((errorRes) => throwError(() => errorRes)),
      );
  }

  createPostCategory(categoryData: string): Observable<any> {
    return this.backend.post(`${this.baseUrl}${this.postController}category/create/`, { post_category_name: categoryData }).pipe(
      map((res) => res),
      catchError((errorRes) => throwError(() => errorRes)),
    );
  }

  updatePostCategory(categoryData: string, categoryId: string): Observable<any> {
    return this.backend
      .update(`${this.baseUrl}${this.postController}category/${categoryId}/update/`, { post_category_name: categoryData })
      .pipe(
        map((res) => res),
        catchError((errorRes) => throwError(() => errorRes)),
      );
  }

  deletePostCategory(categoryId: string) {
    return this.backend.delete(`${this.baseUrl}${this.postController}category/${categoryId}/delete/`).pipe(
      map((res) => res),
      catchError((errorRes) => throwError(() => errorRes)),
    );
  }

  activatePostCategory(categoryData: any): Observable<any> {
    return this.backend
      .postWithOptions(`${this.baseUrl}${this.postController}category/request/accept/`, categoryData, this.backend.headers)
      .pipe(map((res) => res));
  }

  declinePostCategory(categoryData): Observable<any> {
    return this.backend
      .postWithOptions(`${this.baseUrl}${this.postController}category/request/decline/`, categoryData, this.backend.headers)
      .pipe(map((res) => res));
  }
}
